import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


import Header from './components/frontend/Header';
import Footer from './components/frontend/Footer';
import ScrollToTop from './components/frontend/ScrollToTop';
import Home from './components/frontend/Home';
import About from './components/frontend/About';
import Membership from './components/frontend/Membership';
import Members from './components/frontend/Members';
import Contact from './components/frontend/Contact';
import Privacy from './components/frontend/Privacy';
import Terms from './components/frontend/Terms';
import Refund from './components/frontend/Refund';
import Registration from './components/frontend/Registration';
import Committee from './components/frontend/Committee';
import Publications from './components/frontend/Publications';


import Login from './services/Login';
import PrivateRoute from './services/PrivateRoute';



function App() {
  return (
    <>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/members" element={<Members />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/committee" element={<Committee />} />
            <Route path="/publications" element={<Publications />} />

            <Route path="/login" element={<Login />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;